// extracted by mini-css-extract-plugin
module.exports = {"updateInfoWrapper":"UpdateTermsInfo_updateInfoWrapper__31Siv","info":"UpdateTermsInfo_info__2NclB"};